/* eslint-disable react-hooks/exhaustive-deps */
import Modal from "components/global/modal";
import { useTabs} from "react-headless-tabs";
import { TabSelector } from "./tab-selector";
import { BiCheck } from "react-icons/bi";
import { useState, useEffect,useRef,useMemo } from "react";
import Button from "components/button/button";
import VideoGuide from "./components/video-guide";
import ImageSection from "./components/image";
import { useTranslation } from "react-i18next";
import AboutYou from "./components/about-you";
import MilestoneOnBoarding from "./components/milestones";
import { motion,AnimatePresence  } from "motion/react";
import { urlSerializer } from "utils/utils";
import { useOccupations } from "redux/modules/occupation/hooks";
import _, { set } from "lodash";
import { currentLang } from "utils/utils";
import toast from "react-hot-toast";
import LoadingIndicator from "assets/svg/loading-indicator";
import { useIsMobile } from "utils/use-mobile";
import ReactPlayer from "react-player";
import { onboarding_ABOUT_YOU, onboarding_MILESTONE_VIDEO, onboarding_WELCOME_VIDEO, onboarding_PROFILE_VIDEO } from "utils/constant";

const GetStarted = ({hide, profile,userData})=>{

    const { http } = global.services;
    const {t} = useTranslation();
    
    const [selectedTab, setSelectedTab] = useTabs([
        "videoGuide",
        "images",
        "aboutYou",
        "milestones",
    ]);

    const [completeTab, setCompleteTab] = useState([]);
    const [eableBtn, setEanbleBtn] = useState(["images","videoGuide"]);
    const [goThroughTab, setGoThroughTab] = useState([]);
    const [occupation, setOccupation] = useState([]);
    const [categoriesOptions, setCategoriesOptions] = useState([]);
    const [positionOptions, setPositionOptions] = useState([]);
    const [loading,setLoading] = useState(false);
    const [state, setState] = useState({
        cover_image_album:null,
        preview_covers : [],
        cover_image_file: null,
        validationErrors: null,
        profile_image_file:null,
        pronoun:'',
        address:'',
        city:'',
        state:'',
        country:'',
        media_id:null,
        gender:null,
        milestones:[
            {
                title:'',
                year:null,
                category:null,
                position:null
            },
            {
                title:'',
                year:null,
                category:null,
                position:null
            },
            {
                title:'',
                year:null,
                category:null,
                position:null
            }
        ]
    })
    const [errorMessages, setErrorMessages] = useState([]);
    const [linkVideo,setLinkVid] = useState(onboarding_WELCOME_VIDEO);
    const prevTabRef = useRef(selectedTab); 
    const {
        refresh: refreshOccupation,
        initialize: initializeOccupation,
        setOccupations,
      } = useOccupations();

    const isMobile = useIsMobile();

    const getOccupations = async () => {
        try {
          const url = urlSerializer("public/occupations", {
            user_profile_id: userData.profile.id,
          });
          const { data } = await http.get(url);
          const options = data.map((opt) => ({
            label: opt.name,
            value: opt.id,
            profile_type: opt.profile_type
          }));
          setOccupations(options);
        } catch (err) {
          console.log("getOccupations", err);
        }
      };
      
    const getPositions = async () => {
            try {
            const lang = currentLang();
            const url = urlSerializer("public/positions", {
                user_profile_id: profile.id,
            });
        
            const { data } = await http.get(url);
            const positions = data.map((position) => ({
                label: lang ? (position[lang] || position.name) : position.name,
                value: position.id,
            }));
            setPositionOptions(positions);
            } catch (err) {
            console.log("error@getPositions", err);
            throw err;
            }
    };

    const getCategories = async () => {
        try { 
        const lang = currentLang();
        const url = urlSerializer("public/categories", {
            user_profile_id: profile.id,
        });
        const { data } = await http.get(url); 
        const categories = data.map((c) => ({
            // label: !profile.dateFormat ? (c.english_version || c.name) : c.name,
            value: c.id,
            label: lang ? (c[lang] || c.name) : !profile.dateFormat ? (c.english_version || c.name) : c.name
        }));
        setCategoriesOptions(categories);
        } catch (err) {
        console.log("error@getCategories", err);
        throw err;
        }
    };

    const getCoverPhotos = async () => {

    try {
      const { data } = await http.get("profiles/cover/photos", {
        user_profile_id: userData?.profile.id,
      });
        console.log(data);
        if(data.length > 0){
            setState(prev => {
            return{
                ...prev,
                preview_covers:data
            }
            });
        }
        } catch (err) {
        console.trace("getCoverPhotos", err);
        }
    };
    
    useEffect(()=>{
        getPositions()
        getCategories()
        getCoverPhotos()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    
    useEffect(() => {
        if (initializeOccupation) getOccupations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initializeOccupation]);

    useEffect(() => {
        prevTabRef.current = selectedTab;
    }, [selectedTab]);

    useEffect(() => {
        if((state.cover_image_file || state.cover_image_album) && state.profile_image_file) {
            setCompleteTab((prev) => [...prev, 'images']);
        }else{
            setCompleteTab((prev) => { return prev.filter(item => item !== 'images')})
        }
        if(state.gender && state.address && !_.isEmpty(occupation))
        {
            setCompleteTab((prev) => [...prev, 'aboutYou']);
        }else if (state.gender !== null){
            setEanbleBtn((prev) => [...prev, 'aboutYou']);
        }else{
            setCompleteTab((prev) => { return prev.filter(item => item !== 'aboutYou')})
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state, occupation]);

    useEffect(()=>{
        setSelectedTab("videoGuide");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const createPosition = async (e) => {
        try {
        let { data } = await http.post("/public/positions", {
            user_id: profile.user.id,
            user_profile_id: profile.id,
            position: e.label,
        });
        getPositions();
        return data.data;
        } catch (err) {
        console.log(err);
        }
    };

    const createCategory = async (val) => {
        try {
        let { data } = await http.post("/public/categories", {
            user_id: profile.user.id,
            user_profile_id: profile.id,
            category: val.label,
        });
        getCategories();
        return data.data;
        } catch (err) {
        console.log(err);
        }
    };
 
    const listTab = useMemo (()=> [
        {
            id:0,
            title:"Video Guide",
            value :"videoGuide",
            component: <VideoGuide showText={true} 
                        setCompleteTab={setCompleteTab}
                        setEanbleBtn={setEanbleBtn}
                        getVerified={true}
                        vidLink={linkVideo}
                        fullPlay={false}
                        currentTab={'videoGuide'}
                        />,
            video:onboarding_WELCOME_VIDEO
        },
        {
            id:1,
            title:"Images",
            value :"images",
            component: <ImageSection 
                        userData={userData} profile={profile}
                        setState={setState}
                        state={state}
                        />,
            video:onboarding_PROFILE_VIDEO
        },
        {
            id:2,
            title:"About You",
            value :"aboutYou",
            component: <AboutYou t={t}
                            userData={userData} 
                            profile={profile}
                            setState={setState}
                            state={state} 
                            occupation={occupation}
                            setOccupation={setOccupation}
                            createPosition={createPosition}
                            positionOptions={positionOptions}
                            setPositionOptions={setPositionOptions}

                        />,
            video:onboarding_ABOUT_YOU
        },
        {
            id:3,
            title:"Milestones",
            value :"milestones",
            component: <MilestoneOnBoarding t={t} 
                        userData={userData} 
                        profile={profile}
                        setState={setState}
                        state={state} 
                        getPositions={getPositions}
                        getCategories={getCategories}
                        categoriesOptions={categoriesOptions}
                        positionOptions={positionOptions}
                        setCategoriesOptions={setCategoriesOptions}
                        setPositionOptions={setPositionOptions}
                        errorMessages={errorMessages}
                        createCategory={createCategory}
                        createPosition={createPosition}
                        />,
            video:onboarding_MILESTONE_VIDEO
        }
    ],[categoriesOptions,createPosition, errorMessages, getCategories, getPositions, linkVideo, occupation, positionOptions, profile, state, t, userData,createCategory])

    useEffect(()=>{
        const link = listTab.find(item => item.value === selectedTab)?.video || onboarding_WELCOME_VIDEO;
        setLinkVid(link);
    },[selectedTab,listTab])

    const skipTab = (currentTab='videoGuide')=>{
        if(currentTab === 'aboutYou' && !state.gender) {
            setState((prev) => ({
                ...prev,
                validationErrors: {gender: "Please Select a Gender"}
            }));
            return;
        }
        // alert(currentTab) 
        const tabIndex = listTab.find(list => list.value === currentTab).id || 0;
        setSelectedTab(listTab[tabIndex+1].value);
        setGoThroughTab((prev)=> [...prev,currentTab]);
    }

    const submit = async() => {
        setLoading(true);
        const newErrors = {};
        let hasAtLeastOneComplete = false;
        let isValid = true;
        let newMilestones = [];
        state.milestones.forEach((milestone, index) => {
            const { title, year, position, category } = milestone;
            const isFilled =
            title || year || (position && position.length > 0) || (category && category.length > 0);

            const isComplete =
            title && year && position && category;

            // If partially filled (some fields missing), mark as invalid
            if (isFilled && !isComplete) {
                isValid = false;
                newErrors[index] = {};

                if (!title) newErrors[index].title = "Title is required";
                if (!year) newErrors[index].year = "Year is required";
                if (!position || position.length === 0)
                    newErrors[index].position = "Position is required";
                if (!category || category.length === 0)
                    newErrors[index].category = "Category is required";
            }

            if (isComplete){
                hasAtLeastOneComplete = true;
                newMilestones.push(milestone);
            };
        });

        if (!isValid || !hasAtLeastOneComplete) {
            setErrorMessages(newErrors);
            if (!hasAtLeastOneComplete) {
            toast.error("At least one complete milestone is required.");
            }
            setLoading(false);
            return;
        }

        
        setErrorMessages([]);
        setCompleteTab((prev) => [...prev, 'milestones']);
        setGoThroughTab((prev) => [...prev, 'milestones']);

        let payload = new FormData();
        if (occupation.length > 0) {
            let occupationValues = occupation.map((o) => o.label);
            payload.append("occupations", JSON.stringify(occupationValues));
        } else {
            payload.append("occupations", "");
        }

        if(state.cover_image_album){
            payload.append("cover_media_id", state.media_id);
            payload.append("cover_image_file", null);

        }else{
            payload.append("cover_image_file", state.cover_image_file);
        }

        payload.append("profile_image_file", state.profile_image_file);
        // When gender is "Other" and a custom value was typed, store the custom
        // value (e.g. "wheelbarrow") rather than the literal "Other". Falls back
        // to the plain gender otherwise. (Marker.io MCF-1774)
        if (state.gender === "Other" && state.other_gender) {
            payload.append("gender", state.other_gender);
        } else if (state.gender) {
            payload.append("gender", state.gender);
        }
        payload.append("pronoun", state.pronoun);
        payload.append("address", state.address);
        payload.append("user_id", userData.user.id);
        payload.append("user_profile_id", userData.profile.id);
        payload.append("milestones", JSON.stringify(newMilestones));
        payload.append("_method", "PUT");
        try {
        const { data } = await http.post(
            `public/profiles/let-get-started/${userData.profile.id}`,
                payload,
                {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                }
            );
            if(data){
                hide({data:data.data,success:true, milestone_id:data.milestone_id});
                toast.success("Success Onboarding");

            }
        }catch(e){
            console.log(e);
            toast.error(t('somethingWentWrong'));
        }finally{
            setLoading(false);
        }
    };


    const selectTabDone = (currentTab='videoGuide')=>{
        if(!goThroughTab.includes(currentTab)) return;
        setSelectedTab(currentTab);
    }

    const slideDirection = (nextTab)=>{
        const prevIndex = listTab.find(list => list.value === prevTabRef.current)?.id || 0;
        const currentIndex = listTab.find(list => list.value === nextTab)?.id || 0;
        const direction = currentIndex >= prevIndex ? 1 : -1;

        return {
            initial: { x: `${50 * direction}%`, opacity: 0 },
            animate: { x: 0, opacity: 1 },
            exit: { x: `${-50 * direction}%`, opacity: 0 },
        };
    }
    const enableNextButton = ()=>{
        if("videoGuide" === selectedTab && eableBtn.includes(selectedTab)){
            return false;
        }else if("images" === selectedTab && eableBtn.includes(selectedTab)){
            return false;
        }else if("videoGuide" === selectedTab && eableBtn.includes(selectedTab)){
            return false;
        }else if("aboutYou" === selectedTab && eableBtn.includes(selectedTab)){
            return false;
        }else if("milestones" === selectedTab ){
            return false;
        }
        return true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const variants = useMemo(() => slideDirection(selectedTab), [selectedTab]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const activateNextBtn = useMemo(() => enableNextButton(), [selectedTab,eableBtn]);

    const Footer = ({hideSkip=false}) => {
        return (
          <>
            <div 
                className={`border-t py-2 border-light-gray px-3 ${!hideSkip ? "w-full flex items-center justify-between 1sm:justify-between space-x-2" : "w-full"}`}>
              {
                (selectedTab !== "milestones" && !hideSkip) ?
                <div className="text-primary cursor-pointer font-semibold" onClick={()=>{skipTab(selectedTab)}}>
                    Skip this part
                </div>
                : <div></div>
              }
              
              <Button
                key="save-btn-next"
                buttonName={selectedTab === 'milestones' ? 'Next' : 'Next'}
                buttonClass={`bg-primary py-4 px-8 hover:bg-darkPrimary min-w-[7rem] ${hideSkip && 'w-full'}`}
                buttonTextClass="w-full text-white text-sm font-semibold flex items-center justify-center"
                onClick={()=>{selectedTab === 'milestones' ? submit() : skipTab(selectedTab)}} 
                disabled={activateNextBtn || loading}
                loadingIcon={
                      loading ? (
                        <LoadingIndicator className="text-white w-4 h-4 ml-2" />
                    ) : null
                    }
              />
            </div>
          </>
        );
      };

    const WrapText = ({tabName, position , title})=>{
        return (

            <div className={`w-full flex  
                ${selectedTab === tabName ? "text-primary" : goThroughTab.includes(tabName) ? "text-lightBlack" : "text-light-gray"
                }
                `}>
                {completeTab.includes(tabName) ? (
                    <div className="w-6 h-6 rounded-full bg-lightGreen flex justify-center items-center text-sm mr-3">
                    <BiCheck className="text-white text-base" />
                    </div>
                ) : (
                    <div className="w-6 h-6 rounded-full border-2 flex justify-center items-center text-sm mr-3">
                    {position}
                    </div>
                )}
                {title}
            </div>
        )
    }

    return (
        isMobile ? 
        <AnimatePresence>
            <div 
                className="fixed z-[999] inset-0 modal-animation"
                aria-labelledby="modal-title"
                role="dialog"
                aria-modal="true"
            >
                <div className="fixed inset-0 bg-black bg-opacity-70 transition-opacity"aria-hidden="true"/>
                <motion.div
                    initial={{ y: 50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{  y: -50, opacity: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                    className="fixed bottom-0 bg-white min-h-[92dvh] w-full rounded-t-lg"
                >
                <nav className="flex w-full items-center justify-center space-x-2 px-2">
                    {
                        listTab.map(list => {
                            return(
                                <div className="flex-1" key={list.id}>
                                    <TabSelector
                                        isMobile={isMobile}
                                        isActive={selectedTab === list.value}
                                        goThroughTab = {goThroughTab.includes(list.value)}
                                        onClick={()=>selectTabDone(list.value)}
                                        shadeNav= {listTab.find(item => item.value === selectedTab).id >= list.id}
                                        >
                                    </TabSelector>
                                </div>
                            )
                        })
                    }
                    </nav>
                <div className={`relative px-2 relative overflow-y-auto overflow-x-hidden flex flex-col justify-between h-[90dvh]`}>
                    <div className="flex-1"> 
                    <div className="flex justify-between my-4">
                        <div className="text-sm">
                            Step {
                                listTab.find(item => item.value === selectedTab).id + 1
                            } of 4
                        </div>
                        <div>
                            {
                                selectedTab !== "milestones" ?
                                <div className="text-primary cursor-pointer font-semibold" onClick={()=>{skipTab(selectedTab)}}>
                                    Skip this part
                                </div>
                                : <div></div>
                            }
                        </div>
                    </div> 
                    {
                        selectedTab === 'videoGuide' &&
                        <div className="mb-4">
                            <p className="text-base 2sm:text-3xl text-lightBlack font-bold tracking-tighter mb-2">
                                Let's Get Started
                            </p>
                            <p className="text-xs 2sm:text-base">Congrats! You've created a Milestones Page for {profile?.profile_name}. Add more details so people can connect with you.</p>
                        </div>
                    }
                    {
                        selectedTab === 'milestones' &&
                        <div className="mb-4">
                            <p className="text-base 2sm:text-3xl text-lightBlack font-bold tracking-tighter mb-2">
                                Add Your First Milestones
                            </p>
                            <p className="text-xs 2sm:text-base">Highlight key achievements to start telling your story.</p>
                        </div>
                    }
                    <div className="w-full relative">
                        <AnimatePresence mode="wait">
                            {
                                listTab.map((list)=>{
                                        return (
                                        <>
                                            {
                                                selectedTab === list.value &&
                                                <motion.div
                                                    key={list.value}
                                                    variants={variants}
                                                    initial="initial"
                                                    animate="animate"
                                                    exit="exit"
                                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                                    >
                                                    {list.component}
                                                </motion.div>
                                            }
                                        </>
                                        )
                                })
                            }
                        </AnimatePresence>
                    </div> 
                    </div>
                    <div className="w-full">
                        {
                            selectedTab !== 'videoGuide' &&
                            <div className="flex gap-2 items-center bg-light-gray">
                                <ReactPlayer
                                        url={linkVideo}
                                        playing={true}
                                        controls={true}
                                        width={140}
                                        height={65}
                                />
                                <div>
                                    <h1 className="font-semibold text-md">Watch the tutorial</h1>
                                    <p className="text-[12px]">Get step-by-step guidance on how to fill out these form.</p>
                                </div>
                            </div>
                        }
                        <div>
                            <Footer hideSkip={true}/>
                        </div>
                    </div>
                </div>
                </motion.div>
            </div>
        </AnimatePresence>
        :
        <div className="w-full relative">
            <Modal
                footer={<Footer />}
                width="w-19/20 md:w-16/20 2md:w-12/20 3md:w-9/20 1xl:w-8/20"
                contentClassName="rounded-lg overflow-auto custom-scroll"
                wrapperClassName="overflow-visible"

            >
                <div className="w-full 4sm:px-8.5 py-6 relative">
                    <AnimatePresence>
                        {
                        selectedTab !== 'videoGuide' ?
                            <motion.div
                                initial={{ opacity: 0, scale: 0.60 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0.60 }}
                                transition={{ duration: 0.4, ease: "easeInOut" }}
                                className="hidden 2md:block absolute top-[0.5rem] -right-[21rem] bg-white w-[20rem] p-4 rounded-md">
                                <div className="relative">
                                    <h1 className="font-semibold text-sm px-2">Watch the tutorial</h1>
                                    <p className="text-xs px-2">Get step-by-step guidance on how to fill out these form.</p>
                                    <div className="overflow-hidden">
                                        <VideoGuide
                                            fullPlay={true}
                                            activateAudio={false}
                                            preview={false}
                                            className="w-full h-full"
                                            vidLink={linkVideo}
                                            currentTab={selectedTab}
                                        />
                                    </div>
                                    <div
                                        className={`absolute z-0 -left-[1.5rem] top-[18px] w-4 h-4 bg-white transform rotate-45 -transalte-x-1/2`}
                                    ></div>
                                </div>
                            </motion.div>
                            : null
                        }
                    </AnimatePresence>

                    <div className="w-full relative"> 
                        <div className="px-3">
                            <p className="text-base 2sm:text-3xl text-lightBlack font-bold tracking-tighter">
                                Let's Get Started
                            </p>
                            <p className="text-xs 2sm:text-base">Congrats! You've created a Milestones Page for {profile?.profile_name}. Add more details so people can connect with you.</p>
                        </div>
                        
                        <nav className="flex w-full border-b border-gray-300 items-center justify-center mb-8 flex-wrap">
                            {
                                listTab.map(list => {
                                    return(
                                        <div className="flex-1" key={list.id}>
                                            <TabSelector
                                                isActive={selectedTab === list.value}
                                                goThroughTab = {goThroughTab.includes(list.value)}
                                                onClick={()=>selectTabDone(list.value)}
                                                >
                                                <WrapText tabName={list.value} position={list.id + 1} title={list.title}/> 
                                            </TabSelector>
                                        </div>
                                    )
                                })
                            }
                        </nav>
                        <div className="w-full relative max-h-[65dvh] overflow-y-scroll overflow-x-hidden">
                            <AnimatePresence mode="wait">
                                {
                                    listTab.map((list)=>{
                                         return (
                                            <>
                                                {
                                                    selectedTab === list.value &&
                                                    <motion.div
                                                        key={list.value}
                                                        variants={variants}
                                                        initial="initial"
                                                        animate="animate"
                                                        exit="exit"
                                                        transition={{ duration: 0.3, ease: "easeInOut" }}
                                                        >
                                                        {list.component}
                                                    </motion.div>
                                                }
                                            </>
                                         )
                                    })
                                }
                            </AnimatePresence>
                        </div>
                    </div> 
                </div>
            </Modal>
        </div>
    );
}

export default GetStarted;